module.exports = __webpack_public_path__ + "static/media/communal-nsw.44925c80.png";